<template>
  <div id="nav-top">
    <section class="header-top">
      <div class="left-nav" >
        <img src="../assets/img/logo.svg" alt="" @click="joinSchoolnet"/>
        <ul style="padding-left: 30px;">
          <li v-for="(item, index) in list" :key="index" :class="{ active: cur === index }" @click="headeact(index,item.page)">
            {{ item.name }}
          </li>
        </ul>

         <div class="unlogin"  v-if="loginstate==false">
          <a @click="tologin()"><img src="../assets/img/index/xy_login.svg"  /> 学员登录</a>
          <a href="https://jxjypt.luas.edu.cn/admin"><img src="../assets/img/index/gly_login.svg"/> 管理员登录</a>
        </div>

		<div class="login" v-if="loginstate==true" >
			<a href="#" style="font-size: 0.33926rem;" @click="toMessage()"><img src="../assets/img/index/icon_notice.svg"  /> 消息</a>
			<a @mouseenter="ourmession()" @click="toOur()" style="font-size: 0.33926rem;"><img src="../assets/img/index/icon_personal.svg" /> 我的</a>
		</div>


		<!-- 划过之后的效果 -->
		<div class="mession" v-show="show" @mouseleave="oueleave()" v-if="loginstate==true">
		  <div class="our">
		    <img :src="userImg==null || userImg=='' ||  userImg=='undefined' ? url:$api.url+userImg" alt=""/>
		    <div class="ourright">
		      <div class="name">姓名:{{ userName }}</div>
		      <div class="id">证件号:{{ userIdcard}}</div>
			  <div class="id">手机号:{{ mobile}}</div>
		    </div>
		  </div>
		  <div class="quit" @click="exit">退出账号</div>
		</div>
      </div>
    </section>


    <div class="xiaochegnxuBox">
      <div class="xiaochengxu">
        <img src="../assets/img/index/xcx.jpg" />
        <span>继续教育平台小程序</span>
      </div>
    </div>


    <!--<div class="tongzhi" v-if="tongzhiShow">
      <div class="tongzhi_title">关于近期学员学时计算的公告</div>
      <div class="tongzhi_con">　　近期上级主管部门对本基地平台巡检时发现，有部分学员存在同时打开多浏览器标签页同时进行学习的行为，严重影响了学员学时的真实性和学员学习的公平性。经整改，对存在同时学习的记录进行清理优化，并且同时学习的章节的课时将不再计入学时记录。</div>
      <div class="closeBtn" @click="tongzhiClose()">×</div>
    </div>-->
	<!-- <div class="tongzhi" v-if="tongzhiShow">
	  <div class="tongzhi_title">关于停止本年度的学习通知公告</div>
	  <div class="tongzhi_con">　根据甘人社通[2024]194号《关于做好2024年专业技术人员继续教育工作的通知》文件精神，本年度学习时间于2024年11月30日结束，本平台已停止本年度的学习报名和缴费，同时学习学时将不再进行记录。特此通知。</div>
	  <div class="closeBtn" @click="tongzhiClose()">×</div>
	</div> -->
    <div class="tongzhi" style="margin-top: 240px;" v-if="tongzhiShow2">
      <div class="tongzhi_con">　本平台为互联网非涉密平台，严禁传输处理上传涉密文件或国家秘密。</div>
      <div class="closeBtn" @click="tongzhiClose2()">×</div>
    </div>

  </div>
</template>
<script>

import {queryLoginState} from '@/api/login.js'

export default {
  name: 'headerNav',
  props: {
    cur: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tongzhiShow:false,
	  tongzhiShow2:true,
      show: false,
      url: require("../assets/img/index/userLog.jpeg"),
      list: [
		  {name:'首页',page:'/'},
		  {name:'资讯',page:'/information'},
		  {name:'课程',page:'/course'},
		  {name:'名师',page:'/teacher'},
		  {name:'关于',page:'/about'},
		  {name:'证书',page:'/cert'},
		  {name:'考试',page:'/exam'}
	  ],
      loginstate: false,
      token: '',
      user: '',
	  userName:localStorage.getItem('user_name'),
	  userIdcard:localStorage.getItem('id_card'),
	  mobile:localStorage.getItem('user_mobile'),
    userImg:localStorage.getItem('user_img'),
    };
  },

  created() {
  	this.token = localStorage.getItem('token');
  	if (this.token == null || this.token == '') {
  	  this.loginstate = false;
  	} else {
  	  this.queryLoginState();
  	}
  },
  methods: {
	joinSchoolnet(){
	   window.open('https://www.luas.edu.cn/');
	},
    tongzhiClose(){
       this.tongzhiShow = false;
    },
	tongzhiClose2(){
	   this.tongzhiShow2 = false;
	},
    exit() {
        localStorage.clear()
        this.loginstate = false;
		location.reload();
        this.$router.push('/');
    },
    queryLoginState() {
		queryLoginState({}).then(res => {
			if (res.code == 200) {
				this.loginstate = true;
				return;
			} else{
				localStorage.clear();
				this.loginstate = false;
				this.$router.push('/user/login');
				return;
			}
		})
    },
    headeact(index,page) {
		this.cur = index;
        this.$router.push(page);
    },
    ourmession() {
        this.show = true;
    },
	//跳转到消息页面r
	toMessage() {
	    this.$router.push('/our');
	},
	tologin() {
	    this.$router.push('/user/login');
	},
    oueleave() {
        this.show = false;
    },
    toOur() {
        this.$router.push('/our');
    },
  },
};
</script>
<style lang="less" scoped>
#nav-top {
  height: 85px;
  padding: 0 2%;
  //   background: #2961EF;
  .header-top {
    height: 85px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: auto;
        height: 55px;
      }

      ul {
        display: flex;
        margin-left: 70px;

        li {
          width: 85px;
          height: 85px;
          line-height: 85px;
          font-size: 18px;
          text-align: center;
          cursor: pointer;
        }
        li:hover{
          color: #2961EF;
        }
        .active {
          position: relative;
          border-top: 3px;
          border-top:3px solid #2961EF;
          color: #2961EF;
        }
      }
	  .unlogin{
	    width: 364px;
	    height: auto ;
	    text-align: right;
	    display: flex;
	    align-items: center;
	    justify-content: flex-end;
	    a{
	      width: auto;
	      height: 35px;
	      border-radius: 35px;
	      margin-left: 20px;
	      padding: 0 5px;
	      display: flex;
	      color: #2961EF;
	      font-size: 14px;
	      align-items: center;
	      justify-content: center;
	      position: relative;
	      img{ width: auto; height: 28px; margin-right:5px; }
	    }

	    a:hover{
	      img{
	        filter: brightness(0);
	      }
	    }
	  }
      .login{
        width: 364px;
        height: auto ;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        a{
          width: auto;
          height: 35px;
          border-radius: 35px;
          margin-left: 20px;
          padding: 0 5px;
          display: flex;
          color: #2961EF;
          font-size: 14px;
          align-items: center;
          justify-content: center;
          position: relative;
          img{ width: auto; height: 28px; margin-right:5px; }
        }

        a:hover{
          img{
            filter: brightness(0);
          }
        }
      }

    }
  }

  .right-icon {
    display: flex;
    align-items: center;

    div {
      img {
        width: 44%;
        height: auto;
        margin-right: 30px;
      }
    }

    .remind {
      position: relative;

      .circle {
        width: 9px;
        height: 9px;
        background: #ff3434;
        border-radius: 50%;
        position: absolute;
        width: 9px;
        left: 15px;
        top: -5px;
      }
    }
  }

  .mession {
    box-sizing: border-box;
    width: 387px;
    position: fixed;
    right: 0;
    top: 0px;
    margin-top: 70px;
    z-index: 1000000;
    background: rgba(255, 255, 255, 0.8);
    padding: 20px 29px;

    .our {
      padding-bottom: 19px;
      display: flex;
      align-items: center;
      border-bottom: 1px dashed rgba(51, 51, 51, 0.3);

      img {
        width: 76px;
        height: 75px;
        border-radius: 50%;
        border: 2px solid #ffffff;
      }

      .name {
        font-size: 19px;
        color: #333333;
      }

      .id {
        font-size: 14px;
        color: #333333;
        margin-top: 10px;
      }
    }

    .listbox {
      display: flex;
      justify-content: space-between;
      align-content: center;
      border-bottom: 1px dashed #333333;
      padding: 19px 0;

      div {
        text-align: center;
        font-size: 16px;
        color: #333333;

        img {
          margin: 0 auto;
          width: 26px;
          height: 30px;
          display: block;
          margin-bottom: 7px;
        }
      }
    }

    .quit {
      font-size: 17px;
      color: #333333;
      text-align: center;
      margin: 0 auto;
      margin-top: 18px;
    }
  }
}
.xiaochegnxuBox{
  position: fixed;
  width: 100%;
  height: 1px;
  top: 85px;
  left: 0;
  z-index: 99;
  .xiaochengxu{
    width: 150px;
    height: 180px;
    float: right;
    margin: 15px 15px 0 0;
    img{
      width: 140px;
      height: 140px;
      background: #f1f1f1;
      padding:5px;
      float: left;
      display: block;
    }
    span{
      width: 150px;
      height: 30px;
      line-height: 20px;
      float: left;
      display: block;
      font-size: 14px;
      text-align: center;
      background: #f1f1f1;
    }
  }
}

.tongzhi{
  position: fixed;
  right: 15px;
  top: 300px;
  width: 300px;
  height: auto;
  background: #cccccc;
  z-index: 999999;
  background: rgba(255,255,255,.9);
  border: 3px solid #0b7eff;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,.3);
  padding:15px 20px;
  display: flex;
  flex-flow: column;
  .tongzhi_title{
    width: 100%;
    height: auto;
    padding:0 0 5px 0;
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
    color: #0b7eff;
  }
  .tongzhi_con{
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 24px;
  }
  .closeBtn{
    position: absolute;
    top: -10px;
    right: 5px;
    color: #0b7eff;
    font-size: 32px;
    cursor: pointer;
  }
}
</style>
